<template>
    <!-- {{ item }} -->
    <div class="p-3 rounded-[10px] border-[1px] border-[#CCCCCC] bg-white cursor-pointer">
        <div class="flex items-center !justify-between !w-full">
            <div class="flex justify-start items-center gap-1">
                <div class="w-1.5 h-1.5 rounded-full bg-purple-100"></div>
                <div class="w-6 h-1.5 rounded-full bg-purple-100"></div>
                <p class="text-lg font-semibold font-roboto pl-2 m-0 text-fuchsia-700">New Plan <span
                        class="text-[14px] font-roboto font-normal text-[#999999]">({{ item.trade_name }})</span></p>
            </div>
            <div>
                <h6 class="m-0 font-roboto font-medium mobile:text-[16px] laptop:text-[18px] text-[#EA8A8A]">12 months
                    plan</h6>
            </div>
        </div>
        <div class="mobile:block tablet:flex justify-between tablet:items-start desktop:items-center">
            <h2
                class="mobile:my-2 table:m-0 mobile:text-[18px] desktop:text-[22px] tablet:w-[70%] dektop:w-auto text-[#333333] font-roboto font-medium">
                {{ item.plan_name }}</h2>
            <h2 class="m-0 mobile:text-[22px] desktop:text-[30px] text-[#333333] font-roboto font-bold">${{ $helper.formatAmount(item.total_amount)
                }} <span class="font-medium mobile:text-[14px] desktop:text-[18px]">/mo</span></h2>
        </div>
        <div class="protectionPlanSearchCardDetail" v-html="item.description"></div>
    </div>
</template>

<script>
export default {
    props: ["item"],
}
</script>

<style>
.protectionPlanSearchCardDetail ul {
    padding: 0;
    text-align: left;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
}

.protectionPlanSearchCardDetail ul li {
    padding-left: 2rem;
    position: relative;
    width: 50%;
}

.protectionPlanSearchCardDetail ul li:after {
    position: absolute;
    content: "";
    top: 2px;
    left: 0;
    background-image: url('../../assets/images/double-check-pruple.png');
    background-position: center;
    background-size: contain;
    width: 22px;
    height: 22px;
}

.protectionPlanSearchCardDetail p a,
.protectionPlanSearchCardDetail a {
    color: #A084E8;
}

.protectionPlanSearchCardDetail ul li span,
.protectionPlanSearchCardDetail p span {
    font-size: 16px !important;
}

@media (max-width: 767.98px) {
    .protectionPlanSearchCardDetail ul {
        display: block;
        margin-top: 0.5rem;
    }

    .protectionPlanSearchCardDetail ul li {
        width: 100%;
    }
}
</style>